<template>
  <!-- 风格 1 -->
  <div class="v1-style" :style="getStyleContainerStyle()" @click="handleClick">
    <div class="header-left">
      <img class="header-bg" src="@/assets/img/style1/new_header_left_bg.png" />
      <div class="header-left-show-infos">
        <div class="info-item">
          <p :style="getHeaderInfopStyle()">
            <i class="iconfont icon-chaye"></i>
            湿度 {{ humidity }} %
          </p>
        </div>
        <div class="info-item">
          <p :style="getHeaderInfopStyle()">
            <i class="iconfont icon-IOTtubiao_huabanfuben"></i>
            {{ temperature }} °C
          </p>
        </div>
        <div class="info-item" @click="toggleChartShow">
          <p :style="getHeaderInfopStyle()">
            <el-tooltip :content="!isHideAllCharts ? '隐藏全部图表' : '显示全部图表'" placement="bottom">
              <i :class="!isHideAllCharts ? 'iconfont icon-huabankaobei-' : 'iconfont icon-yanjing-guan'"></i>
            </el-tooltip>
          </p>
          <div
            class="icon"
            :style="getHeaderInfopStyle()"
            v-if="icon1?.iconUrl"
            @click.stop="handleJump(icon1?.url)"
          >
            <el-tooltip :content="headerIcon1Name" placement="bottom">
              <img :src="icon1.iconUrl" alt="" />
            </el-tooltip>
          </div>
          <div
            class="icon icon2"
            :style="getHeaderInfopStyle()"
            v-if="icon2?.iconUrl"
            @click.stop="handleJump(icon2?.url)"
          >
            <el-tooltip :content="headerIcon2Name" placement="bottom">
              <img :src="icon2.iconUrl" alt="" />
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="header-middle">
      <img class="header-bg" src="@/assets/img/style1/header_middle_picture.png" />
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(26, $store) + 'px',
          lineHeight: $h_Ratio(style.height - 8, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>
      <div class="spotlight-ct">
        <div class="spotLight1"></div>
        <div class="spotLight2"></div>
      </div>
    </div>
    <div class="header-right">
      <img class="header-bg" src="@/assets/img/style1/new_header_right_bg.png" />
      <div class="header-right-show-infos">
        <div class="info-item1">
          <p :style="getHeaderInfopStyle()">{{ `${city} ${weather} ${temperature}°C` }}</p>
        </div>
        <div class="info-item2">
          <div
            class="info-item2-wrapper"
            :style="{
              transform: `scale(${$h_Ratio(1, $store)})`,
            }"
          >
            <div class="info-item2-hour">
              <div v-for="(item, index) in timeString" :key="index">
                <img :src="`./img/timeicons/timeIcon${item}.png`" alt="" />
              </div>
            </div>
            <div class="info-item2-date">
              <div v-for="(item, index) in dateString" :key="index">
                <img :src="`./img/timeicons/timeIcon${item}.png`" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="info-item3">
          <p :style="getHeaderInfopStyle()">
            <!--<span>控件</span>-->
          </p>
        </div>
      </div>
    </div>
    <div
      class="right-icon"
      :style="getRightInfopStyle()"
      v-if="icon3?.iconUrl"
      @click.stop="handleJump(icon3?.url)"
    >
      <div>
        <img :src="icon3.iconUrl" alt="" />
      </div>
      <div class="right-name">
        {{ headerIcon3Name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'V1Style',
  components: {},
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 72,
      },
      timeString: '',
      dateString: '',
      cityName: '',
      city: '',
      humidity: '',
      temperature: '',
      weather: '',
      icon1: { isShowIcon: false, iconUrl: '', url: '' }, // 图标1
      icon3: { isShowIcon: false, iconUrl: '', url: '' }, // 图标1
      icon2: { isShowIcon: false, iconUrl: '', url: '' }, // 图标2
      headerIcon3Name: '',
      headerIcon2Name: '',
      headerIcon1Name: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.headerIcon3Name = val.propertyData.headerIcon3.value.name;
        this.onConfigurationChange();
      },
    },
  },
  created() {
    this.onConfigurationChange();
    this.autoGetTime();
  },
  mounted() {
    this.headerIcon2Name = this.Configuration.propertyData?.headerIcon2?.value?.name;
    this.headerIcon1Name = this.Configuration.propertyData?.headerIcon1?.value?.name;
    this.headerIcon3Name = this.Configuration.propertyData?.headerIcon3?.value?.name;
  },
  methods: {
    handleJump(url) {
      if (url) {
        window.open(url);
      } else {
        this.$ElMessage.warning('请配置地址！');
      }

      console.log('跳转地址', url);
    },
    getRightInfopStyle(fs = 14, pt = 15) {
      return {
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    toggleChartShow() {
      console.log('00000000000');
      if (!this.isHideAllCharts) {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'hide',
          isAll: true,
        });
      } else {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'norm',
          isAll: true,
        });
      }
    },
    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
      this.cityName = this.Configuration.propertyData.cityName.value;
      this.icon1 = this.Configuration?.propertyData?.headerIcon1?.value;
      this.icon2 = this.Configuration?.propertyData?.headerIcon2?.value;
      this.icon3 = this.Configuration?.propertyData?.headerIcon3?.value;
      this.getWeather();
    },
    getWeather() {
      this.axios({
        method: 'get',
        url: `https://restapi.amap.com/v3/weather/weatherInfo?city=${this.cityName}&output=json&key=db5d2728c584e5884c385c2a509b29b9`,
        dataType: 'jsonp',
      }).then(res => {
        if (res.status === 200) {
          if (!(res.data.lives[0] instanceof Array)) {
            // console.log(res.data.lives[0]);
            let { humidity, temperature, weather, city } = res.data.lives[0];
            this.humidity = humidity;
            this.temperature = temperature;
            this.weather = weather;
            this.city = city;
          } else {
            this.$ElMessage.warning('定位不到该城市！');
          }
        }
      });
    },
    getHeaderInfopStyle(fs = 14, pt = 0) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
        // transform: `scale(${this.$w_Ratio(1, this.$store)})`,
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        // backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function (value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
    }),
  },
  Configuration: {
    componentTitle: '空谷幽兰',
    componentName: 'V1Style',
    componentOverViewImg: './img/styles/style-1.png',
    backgroundImg: './img/backgrounds/background_img/V6.png',
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: '#19242D',
        lable: '头部背景颜色',
      },
      menuStyle: {
        value: {
          height: 85,
          width: 700,
        },
      },
      headerIcon1: {
        propertyComponentName: 'HeaderIcon1Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon2: {
        propertyComponentName: 'HeaderIcon2Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon3: {
        propertyComponentName: 'HeaderIcon3Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
    },
    // 该风格下的各个图表的样式
    chartsStyle: {
      // 柱状图
      barStyle: {
        // x轴
        xAxis: {
          axisLine: {
            //坐标轴颜色
            lineStyle: {
              color: '#fff',
            },
          },
        },
      },
      // 折线图
      lineStyle: {},
      // 饼图
      pieStyle: {},
      // 雷达图
      radarStyle: {},
      // 表格
      tableStyle: {},
      // 地图
      earthStyle: {},
      // 仪表图
      gaugeStyle: {},
      // 其他
      othersStyle: {},
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v1-style {
  z-index: 99;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: space-between;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.765) 45%, transparent 100%);
  background: url(../../../assets/img/style1/top_background_bar.png);
  background-size: 100% 100%;
  .header-left {
    max-width: 680px;
    width: 38%;
    height: 94%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-left-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.33%;
        height: 100%;
      }
    }
  }
  .right-icon {
    z-index: 1000;
    background: #031943;
    position: absolute;
    right: 0;
    bottom: -900%;
    width: 26px;
    height: 80px;
    border-radius: 6px 0 0 6px;
    border-top: 1px solid #148ddd;
    border-bottom: 1px solid #148ddd;
    border-left: 1px solid #148ddd;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    .right-name {
      color: #fff;
      line-height: 28px;
      writing-mode: vertical-lr;
    }
    img {
      display: none;
    }
  }
  .right-icon:hover {
    width: 165.6px;
    height: 144px;
    padding: 0 10px;
    justify-content: space-between;
    border: none;
    .right-name {
      line-height: 16px;
      position: relative;
      left: 6px;
    }
    img {
      display: block;
      width: 150px;
    }
  }
  .header-middle {
    width: 36.5%;
    height: 100%;
    flex-shrink: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;

    .header-bg {
      width: 100%;
      height: 146%;
      position: absolute;
      top: 0;
    }

    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      color: #f1f8f7;
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;

      p {
        margin: 0;
      }
    }

    .spotlight-ct {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-49.5%);
      width: 41%;
      height: 30%;
      overflow: hidden;
      // background-color: rgba(204, 204, 204, 0.308);
      .spotLight1 {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 28%;
        height: 20%;
        transform: translate(-50%, -50%);
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #ffffff 12%,
          rgba(189, 91, 87, 0) 60%,
          rgba(189, 91, 87, 0) 69%
        );
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      .spotLight2 {
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          rgb(255, 255, 255) 9%,
          rgba(189, 91, 87, 0) 75%,
          rgba(189, 91, 87, 0) 73%
        );
        width: 9%;
        height: 20%;
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 11%;
        height: 14%;
        transform: translate(-50%, -50%);
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      @keyframes titlelight {
        0% {
          left: -40%;
          opacity: 1;
          transform: scale(1.2, 1.3) translate(-50%, -50%);
        }
        35% {
          opacity: 0.7;
          transform: scale(1.6, 1.5) translate(-50%, -50%);
        }

        50% {
          opacity: 1;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }
        75% {
          opacity: 0.5;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        100% {
          left: 120%;
          opacity: 1;
          transform: scale(1.2, 1.2) translate(-50%, -50%);
        }
      }
    }
  }

  .header-right {
    max-width: 680px;
    width: 38%;
    height: 94%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-right-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 30%;
      display: flex;

      .info-item1 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 100%;
        color: #95ccff;
      }

      .info-item2 {
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: center;
        width: 33.33%;
        height: 100%;

        .info-item2-wrapper {
          width: 100%;
          height: 80%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .info-item2-hour {
          margin-left: 30%;
          display: flex;
          height: 34%;
          width: 70%;

          div {
            height: 100%;
            width: 10%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        .info-item2-date {
          margin-top: 5%;
          display: flex;
          height: 30%;
          width: 70%;

          div {
            height: 100%;
            width: 10%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        p {
          margin: 0;
          padding: 0;
        }
      }

      .info-item3 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40%;
        height: 100%;
      }
    }
  }
}
.icon {
  margin-left: 25px;
  position: relative;
  z-index: 99;
  img {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
}
.icon2 {
  // margin-left: 0;
}
</style>
